module.exports = __webpack_public_path__ + "static/media/my_tweet (2).5acc4780.jpg";